import { create } from "zustand";

const useBundlesStore = create((set) => ({
  bundles: [],
  setBundles: (bundles) => {
    return set({ bundles });
  },
  addBundle: (bundle) =>
    set((state) => ({ bundles: [...state.bundles, bundle] })),
  updateBundle: (updatedBundle) =>
    set((state) => ({
      bundles: state.bundles.map((bundle) =>
        bundle.id === updatedBundle.id ? updatedBundle : bundle
      ),
    })),
  removeProduct: (id) =>
    set((state) => ({
      bundles: state.bundles.filter((bundle) => bundle.id !== id),
    })),
}));

export default useBundlesStore;
